export const invoiceList = {
  head: {
    title: "Faturamento",
    subtitle: "Faturas emitidas para os seus hóspedes",
  },
  stats: {
    filterAria: "Filtrar faturas por status",
    total: "Total",
    draft: "Rascunhos",
    sent: "Emitidas",
    processing: "Processando",
    error: "Com erros",
    pending: "Pendentes",
    voided: "Anuladas",
  },
  toolbar: {
    searchLabel: "Buscar faturas",
    searchPlaceholder: "Nº da fatura, cliente, e-mail, identificação fiscal ou reserva…",
    clearSearch: "Limpar busca",
    propertyLabel: "Acomodação",
    allProperties: "Todas as acomodações",
    typeToSearchProperties: "Digite para buscar acomodações.",
    noProperties: "Nenhuma acomodação encontrada.",
    statusLabel: "Status",
    emisorLabel: "Emissor",
    allEmisores: "Todos os emissores",
    servicesTitle: "Catálogo de cobranças e serviços reutilizáveis",
    services: "Cobranças e serviços",
    createInvoice: "Criar fatura",
  },
  exportZip: {
    button: "ZIP",
    title: "Um arquivo por fatura, cada uma com sua data e seu código de reserva, todas dentro de um ZIP",
    generating: "Gerando…",
    zipping: "Compactando…",
    noPdfInPeriod: "No período não há faturas emitidas com PDF.",
    noPdfInPage: "Nesta página não há faturas emitidas com PDF.",
    tooMany: "A seleção tem {total} faturas e o ZIP admite {limit}. Reduza o período ou os filtros.",
    noneDownloaded: "Não foi possível baixar nenhuma fatura do Invopop. Tente novamente em alguns minutos.",
    failed: "Não foi possível baixar do Invopop {n} fatura(s): {codes}.",
    withoutPdf: "{n} fatura(s) ainda não têm PDF no Invopop e não vão no ZIP: {codes}.",
    restIncluded: "As demais estão no ZIP.",
    error: "Não foi possível gerar o ZIP das faturas.",
  },
  linkedClient: {
    prefix: "Faturas vinculadas a",
    fallbackName: "este cliente de faturamento",
    clear: "Remover filtro de cliente",
  },
  table: {
    numberHeader: "Nº DA FATURA",
    customerHeader: "CLIENTE",
    propertyHeader: "ACOMODAÇÃO",
    totalHeader: "TOTAL",
    statusHeader: "STATUS",
    dateHeader: "DATA",
    actionsHeader: "AÇÕES",
    draftReferenceTitle: "Referência do rascunho. O número fiscal é atribuído na emissão.",
    openReserva: "Abrir a reserva",
    viewCreditNote: "Ver fatura retificativa {code}",
    creditNote: "Fatura retificativa",
    viewError: "Ver erro",
    voids: "Anula",
    correctionOf: "Corr. de",
    correctedBy: "Corrigida por:",
  },
  sortFields: {
    number: "número da fatura",
    customer: "cliente",
    property: "acomodação",
    total: "total",
    status: "status",
    date: "data",
  },
  sort: {
    sortBy: "Ordenar por {label}",
    sortedBy: "Ordenado por {label}, {direction}. Alterar a ordem",
    asc: "crescente",
    desc: "decrescente",
  },
  actions: {
    openPdf: "Abrir fatura como PDF",
    editDraftTitle: "Editar dados do cliente e itens",
    edit: "Editar",
    previewTitle: "Abrir uma prévia sem validade fiscal",
    preview: "Prévia",
    sendQuote: "Orçamento",
    sendQuoteTitle: "Enviar o orçamento por e-mail ao cliente",
    emitTitle: "Revisar e emitir a fatura",
    emit: "Emitir",
    syncTitle: "Atualizar o status da fatura",
    sync: "Atualizar",
    retryTitle: "Tentar novamente com os dados de faturamento atualizados",
    retry: "Tentar novamente",
    moreOptions: "Mais opções",
    moreOptionsAria: "Mais opções da fatura",
    editCustomer: "Editar dados do cliente",
    deleteReset: "Excluir e redefinir pedido",
    voidReissue: "Anular e reemitir",
  },
  empty: {
    searchTitle: "Nenhuma fatura encontrada",
    searchText: "Nenhum resultado corresponde à busca e aos filtros atuais.",
    clearFilters: "Limpar filtros",
    title: "Ainda não há faturas",
    text: "Crie um rascunho e emita-o quando os dados fiscais e as cobranças estiverem prontos.",
    createFirst: "Crie a sua primeira fatura",
  },
  errorModal: {
    title: "Erro na fatura",
    hintBefore: "Se o erro estiver nos seus dados de faturamento (identificação fiscal, série…), corrija-os em",
    hintSettingsPath: "Configurações → Faturamento",
    hintBetween: "e depois use",
    hintRetryWord: "Tentar novamente",
    hintGuest: "Se o erro estiver nos dados do hóspede, use",
    hintEditWord: "Editar dados do cliente",
    close: "Fechar",
    retryNow: "Tentar novamente agora",
  },
  editCustomer: {
    title: "Editar dados do cliente",
    subtitle: "Corrija os dados e tente emitir a fatura novamente",
    name: "Nome / Razão social *",
    taxId: "Identificação fiscal / Número de VAT",
    country: "País (código de 2 letras) *",
    email: "E-mail *",
    address: "Endereço",
    city: "Cidade",
    zip: "Código postal",
    hint: "Ao salvar, o envio da fatura será repetido automaticamente.",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar e tentar novamente",
  },
  deleteConfirm: {
    title: "Excluir fatura",
    body1: "Esta tentativa de fatura será excluída e o",
    bodyStrong: "pedido do hóspede será redefinido",
    body2: ", permitindo que ele insira os seus dados e solicite a fatura novamente.",
    irreversible: "Esta ação não pode ser desfeita.",
    cancel: "Cancelar",
    deleting: "Excluindo…",
    confirm: "Sim, excluir",
  },
  create: {
    titleEdit: "Editar rascunho",
    titleCreate: "Criar fatura",
    subtitleEdit: "Atualize o cliente, o contexto e os itens. Não é emitida.",
    subtitleCreate: "Rascunho — sem número até ser emitida. Não requer reserva.",
    loading: "Carregando rascunho…",
    clientLabel: "Cliente *",
    clientHelp: "Selecione um perfil de faturamento salvo ou crie um novo.",
    newClient: "Novo cliente",
    company: "Empresa",
    individual: "Pessoa física",
    change: "Alterar",
    clientSearchPlaceholder: "Buscar por nome, e-mail ou documento…",
    incomplete: "Incompleto",
    noClients: "Nenhum cliente encontrado.",
    createClient: "Criar cliente",
    contextTitle: "Contexto da fatura",
    optional: "Opcional",
    contextHelp: "Vincule esta fatura para manter a sua rastreabilidade. Você pode deixar os dois campos vazios.",
    propertyLabel: "Acomodação",
    propertyPlaceholder: "Buscar acomodação…",
    typeToSearchProperties: "Digite para buscar acomodações.",
    noProperties: "Nenhuma acomodação encontrada.",
    reservationLabel: "Reserva",
    reservationPlaceholder: "Buscar código, hóspede, e-mail…",
    noHolder: "Sem titular",
    typeToSearchReservations: "Digite para buscar reservas.",
    noReservations: "Nenhuma reserva encontrada.",
    contextNotice: "A reserva define a acomodação e adiciona a estadia se ela ainda não tiver sido faturada.",
    chargesTitle: "Cobranças e serviços",
    chargesHelp: "Selecione itens salvos no seu catálogo.",
    addCharge: "Adicionar cobrança ou serviço",
    colConcept: "Item",
    colQty: "Qtd.",
    colUnitPrice: "Preço unitário",
    colTotal: "Total",
    docTitle: "Como ficará a fatura",
    docHint: "Estas são as linhas que o PDF vai levar. O alojamento, os descontos e os encargos automáticos vêm da reserva: acima só edita os encargos do seu catálogo.",
    due: "Por cobrar",
    assumed: "Não há pagamentos registados nesta reserva. O valor é dado como cobrado a partir da forma de pagamento marcada, e o PDF dirá o mesmo.",
    linesEmpty: "Adicione um ou mais itens do seu catálogo.",
    total: "Total",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveChanges: "Salvar alterações",
    saveDraft: "Salvar rascunho",
  },
  contextSummary: {
    property: "Acomodação selecionada",
    empty: "Adicione acomodação ou reserva",
  },
  emit: {
    title: "Emitir fatura",
    subtitle: "Esta ação atribuirá o número fiscal definitivo.",
    client: "Cliente",
    property: "Acomodação",
    total: "Total",
    warning: "Uma vez emitida, você não poderá editá-la diretamente; qualquer correção exigirá um documento retificador.",
    cancel: "Cancelar",
    emitting: "Emitindo…",
    confirm: "Emitir fatura",
  },
  editDraft: {
    title: "Editar rascunho",
    subtitle: "Modifique os dados do cliente e os itens. Não é emitida.",
    loading: "Carregando rascunho…",
    individual: "Pessoa física",
    individualSub: "Pessoa natural",
    company: "Empresa",
    companySub: "Pessoa jurídica",
    legalName: "Razão social *",
    fullName: "Nome completo *",
    companyNamePlaceholder: "Nome da empresa",
    individualNamePlaceholder: "Nome e sobrenome",
    country: "País *",
    docCompany: "Identificação fiscal da empresa (VAT)",
    docIndividual: "Documento de identidade / Passaporte",
    docCompanyPlaceholder: "VAT / Identificação fiscal",
    docIndividualPlaceholder: "Documento de identidade ou passaporte",
    email: "E-mail",
    emailOptional: "(opcional)",
    lodgingTitle: "Acomodação",
    lodgingName: "Acomodação",
    lodgingNoteBefore: "Obtido da reserva",
    lodgingNoteAfter: ". Para alterar este valor, edite-o na reserva.",
    chargesTitle: "Cobranças e serviços",
    chargesHelp: "Adicione itens salvos sem alterar a acomodação.",
    addCharge: "Adicionar cobrança ou serviço",
    colConcept: "Item",
    colQty: "Qtd.",
    colUnitPrice: "Preço unitário",
    colTotal: "Total",
    linesEmpty: "Nenhum item adicional.",
    linesEmptyReserva: "A fatura inclui apenas a acomodação.",
    total: "Total",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveChanges: "Salvar alterações",
  },
  void: {
    doneTitle: "Fatura anulada",
    doneSubtitle: "Fatura retificativa emitida com sucesso",
    whatHappened: "O que aconteceu?",
    doneCreditNote: "Foi emitida a fatura retificativa",
    doneListed: "A fatura permanece na lista marcada como anulada",
    doneCharges: "As cobranças adicionais foram liberadas",
    doneGuest: "O hóspede pode solicitar a sua fatura novamente",
    nextStepsLabel: "Próximos passos:",
    nextStepsText: "Você pode adicionar ou corrigir cobranças na reserva. Depois, reenvie o link de faturamento ao hóspede.",
    understood: "Entendi",
    title: "Anular e reemitir fatura",
    introBefore: "Esta ação",
    introStrong: "anulará a fatura emitida",
    introAfter: "por meio de uma fatura retificativa oficial.",
    willEmit: "Uma fatura retificativa será emitida",
    willList: "A fatura permanecerá na lista marcada como anulada",
    willFree: "As cobranças adicionais serão liberadas",
    willAllowGuest: "O hóspede poderá solicitar a fatura novamente",
    reasonLabel: "Motivo da anulação",
    reasonOther: "Outro motivo…",
    reasonPlaceholder: "Explique por que você está anulando esta fatura",
    warning: "A fatura retificativa é um documento fiscal oficial. Use-a apenas se você realmente precisar corrigir a fatura.",
    cancel: "Cancelar",
    emitting: "Emitindo fatura retificativa…",
    confirm: "Sim, anular e reemitir",
  },
  statusFilters: {
    all: "Todas",
    draft: "Rascunhos",
    sent: "Emitidas",
    processing: "Processando",
    error: "Com erros",
    pending: "Pendentes",
    voided: "Anuladas",
  },
  voidReasons: {
    wrongTaxData: "Dados fiscais do cliente incorretos",
    wrongAmount: "Valor ou cobranças incorretos",
    duplicate: "Fatura duplicada",
    cancelledReservation: "Reserva cancelada",
    reissue: "Anulada para reemitir com dados ou cobranças corrigidos",
  },
  statusLabels: {
    draft: "Rascunho",
    sent: "Emitida",
    processing: "Processando",
    error: "Erro",
    pending: "Pendente",
    corrected: "Corrigida",
    voided: "Anulada",
  },
  client: {
    fallbackName: "Cliente",
    fiscalPending: "Perfil de faturamento pendente",
    fiscalSaved: "Perfil de faturamento salvo",
  },
  reservation: {
    noCode: "Sem código",
    noDates: "Sem datas",
    noHolder: "Sem titular",
    propertyFallback: "Acomodação #{id}",
  },
  emisorFallback: "Emissor #{id}",
  toasts: {
    selectClientComplete: "Selecione um cliente com um perfil de faturamento completo.",
    selectReservationOrCharge: "Selecione uma reserva ou adicione pelo menos uma cobrança ou serviço.",
    saveDraftError: "Não foi possível salvar o rascunho.",
    createError: "Não foi possível criar a fatura.",
    quoteSent: "Orçamento enviado para {email}",
    quoteError: "Não foi possível enviar o orçamento.",
    previewError: "Não foi possível gerar a prévia.",
    previewName: "Prévia",
    emitRejected: "A plataforma fiscal rejeitou a emissão.",
    emitError: "Não foi possível emitir a fatura. Verifique os dados fiscais e tente novamente.",
    selectClientToContinue: "Selecione um cliente com um perfil de faturamento para continuar.",
    loadDraftError: "Não foi possível carregar os dados do rascunho.",
    nameRequired: "Informe o nome do cliente.",
    countryRequired: "Selecione o país do cliente.",
    selectCatalogCharge: "Selecione pelo menos uma cobrança ou serviço do catálogo.",
    retryError: "A nova tentativa falhou.",
    saveError: "Não foi possível salvar.",
    voidError: "Não foi possível anular a fatura.",
    deleteError: "Não foi possível excluir.",
  },
};
